import React, { useEffect } from 'react';
import { useLocation, useRouteError } from 'react-router-dom';
import { Typography, Box, Container } from '@mui/material';
import { PageLayout } from '@/components/layouts/PageLayout';
import {
	getSafeUserErrorMessage,
	logApplicationError,
	parseRouteErrorData,
} from '@/utils/safeErrorMessage';

export const ErrorPage = () => {
	const error = useRouteError();
	const location = useLocation();

	useEffect(() => {
		logApplicationError('Route error', {
			message: error?.message ?? error?.statusText,
			stack: error?.stack,
			status: error?.status,
			data: error?.data,
			pathname: location.pathname,
			parsedData: parseRouteErrorData(error),
			userAgent: navigator.userAgent,
		});
	}, [error, location.pathname]);

	const userMessage = getSafeUserErrorMessage(
		error,
		'Sorry, an unexpected error has occurred. Please try again or contact support if the problem persists.',
	);

	return (
		<PageLayout>
			<Container>
				<Box sx={{ paddingTop: '4em' }}>
					<Typography variant='h4'>{userMessage}</Typography>
				</Box>
			</Container>
		</PageLayout>
	);
};
